<template>
  <site-banner pagina="clinicas" />

  <site-pesquisa />

  <site-tratamentos />

  <site-noticias />
</template>

<script setup>
const { t, locale } = useI18n();

useSeoMeta({
  title: `Unidades da - ${t("sorrifacil")}`,
  ogTitle: `Unidades da - ${t("sorrifacil")}`,
  description: `Conheça as unidades da - ${t("sorrifacil")}`,
  ogDescription: `Conheça as unidades da - ${t("sorrifacil")}`,
});
</script>

<script>
export default {
  name: "ClinicasPagina",
};
defineI18nRoute({
  paths: {
    pt: "/clinicas",
    es: "/clinica",
  },
});
</script>
